import React from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { SelectExtended } from './core/select-extended';

interface Props {
	label?: string;
	required?: boolean;
	width?: string;
}

const tratos = [
	{ text: 'Sr.', value: 'Sr.' },
	{ text: 'Sra.', value: 'Sra.' },
];

export function TratoSelect(props: Props) {
	const { label } = props;

	return (
		<div style={{ width: props.width || '100%' }}>
			<SelectExtended
				{...props}
				name={FIELD_NAME.TREATMENT}
				label={label ? label : 'Trato'}
				options={tratos}
				value="Sr."
			/>
		</div>
	);
}
